import { render, staticRenderFns } from "./RegisterCertGuideB.vue?vue&type=template&id=b4a4e26a&scoped=true&lang=html&"
import script from "./RegisterCertGuideB.vue?vue&type=script&lang=ts&"
export * from "./RegisterCertGuideB.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterCertGuideB.vue?vue&type=style&index=0&id=b4a4e26a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a4e26a",
  null
  
)

export default component.exports